export const content = {
  en: {
    Monday: {
      short: 'M',
      long: 'Monday',
    },
    Tuesday: {
      short: 'T',
      long: 'Tuesday',
    },
    Wednesday: {
      short: 'W',
      long: 'Wednesday',
    },
    Thursday: {
      short: 'T',
      long: 'Thursday',
    },
    Friday: {
      short: 'F',
      long: 'Friday',
    },
    Saturday: {
      short: 'S',
      long: 'Saturday',
    },
    Sunday: {
      short: 'S',
      long: 'Sunday',
    },
  },
  de: {
    Monday: {
      short: 'M',
      long: 'Montag',
    },
    Tuesday: {
      short: 'D',
      long: 'Dienstag',
    },
    Wednesday: {
      short: 'M',
      long: 'Mittwoch',
    },
    Thursday: {
      short: 'D',
      long: 'Donnerstag',
    },
    Friday: {
      short: 'F',
      long: 'Freitag',
    },
    Saturday: {
      short: 'S',
      long: 'Samstag',
    },
    Sunday: {
      short: 'S',
      long: 'Sonntag',
    },
  },
};
